import React from 'react';

export default function Homepage() {
  return (
    <>
      {/* HERO ============================*/}
      <section className="bg-body-emphasis pb-8" id="home">
        <div className="container-small hero-header-container px-lg-7 px-xxl-3">
          <div className="row align-items-center">
            <div className="col-12 col-lg-auto order-0 order-md-1 text-end order-1">
              <div className="position-relative p-5 p-md-7 d-lg-none">
                <div
                  className="bg-holder"
                  style={{
                    backgroundImage: 'url(../../assets/img/bg/bg-23.png)',
                    backgroundSize: 'contain',
                  }}
                ></div>
                {/*/.bg-holder*/}

                <div className="position-relative">
                  <img
                    className="w-100 shadow-lg d-dark-none rounded-2"
                    src="../../assets/img/bg/bg-31.png"
                    alt="hero-header"
                  />
                  <img
                    className="w-100 shadow-lg d-light-none rounded-2"
                    src="../../assets/img/bg/bg-30.png"
                    alt="hero-header"
                  />
                </div>
              </div>
              <div className="hero-image-container position-absolute top-0 bottom-0 end-0 d-none d-lg-block">
                <div className="position-relative h-100 w-100">
                  <div className="position-absolute h-100 top-0 d-flex align-items-center end-0 hero-image-container-bg">
                    <img
                      className="pt-7 pt-md-0 w-100"
                      src="../../assets/img/bg/bg-1-2.png"
                      alt="hero-header"
                    />
                  </div>
                  <div className="position-absolute h-100 top-0 d-flex align-items-center end-0">
                    <img
                      className="pt-7 pt-md-0 w-100 shadow-lg d-dark-none rounded-2"
                      src="../../assets/img/bg/bg-28.png"
                      alt="hero-header"
                    />
                    <img
                      className="pt-7 pt-md-0 w-100 shadow-lg d-light-none rounded-2"
                      src="../../assets/img/bg/bg-29.png"
                      alt="hero-header"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 text-lg-start text-center pt-8 pb-6 order-0 position-relative">
              <h1 className="fs-3 fs-lg-2 fs-md-1 fs-lg-2 fs-xl-1 fs fw-black mb-4">
                <span className="text-primary me-3">Effortlessly</span>
                <br />
                Perfect
                <br />
                Filenames
              </h1>
              <p className="mb-5">
                Generate consistent and organized filenames in seconds. Simply input your desired
                components and copy the ready-to-use filename! Save time editing multiple files and
                avoid manual errors.
              </p>
              <a className="btn btn-lg btn-primary rounded-pill me-3" href="#feature" role="button">
                Get Started
              </a>
              <a className="btn btn-link me-2 fs-8 p-0" href="#feature" role="button">
                Learn More<span className="fa-solid fa-angle-right ms-2 fs-9"></span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="pt-15 pb-0" id="features">
        <div className="container-small px-lg-7 px-xxl-3">
          <div className="position-relative z-2">
            <div className="row">
              <div className="col-lg-6 text-center text-lg-start pe-xxl-3">
                <h4 className="text-primary fw-bolder mb-4">Features</h4>
                <h2 className="mb-3 text-body-emphasis lh-base">Why Filename Builder?</h2>
                <p className="mb-5">
                  Filename Builder helps you create filenames that are consistent, organized, and
                  easy to duplicate. Instantly copy your filename and use it across multiple files,
                  saving you time and reducing errors.
                </p>
                <a
                  className="btn btn-lg btn-outline-primary rounded-pill me-2"
                  href="#"
                  role="button"
                >
                  Try it Free<i className="fa-solid fa-angle-right ms-2"></i>
                </a>
              </div>
              <div className="col-sm-6 col-lg-3 mt-7 text-center text-lg-start">
                <div className="h-100 d-flex flex-column justify-content-between">
                  <div className="border-start-lg border-translucent border-dashed ps-4">
                    <img
                      className="mb-4"
                      src="../../assets/img/icons/illustrations/bolt.png"
                      width="48"
                      height="48"
                      alt="Lightning Speed"
                    />
                    <div>
                      <h5 className="fw-bolder mb-2">Maintain Consistency</h5>
                      <p className="fw-semibold lh-sm">
                        Ensure all your files follow a uniform naming structure, making them easier
                        to organize, search, and manage.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mt-7 text-center text-lg-start">
                <div className="h-100 d-flex flex-column">
                  <div className="border-start-lg border-translucent border-dashed ps-4">
                    <img
                      className="mb-4"
                      src="../../assets/img/icons/illustrations/pie.png"
                      width="48"
                      height="48"
                      alt="Save Time"
                    />
                    <div>
                      <h5 className="fw-bolder mb-2">Save Time & Reduce Errors</h5>
                      <p className="fw-semibold lh-sm">
                        Stop manually typing long and complex filenames. Our builder eliminates
                        typos and streamlines your workflow.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-12 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
              <div className="col-lg-5">
                <img
                  className="feature-image img-fluid mb-9 mb-lg-0 d-dark-none"
                  src="../../assets/img/spot-illustrations/22_2.png"
                  alt="Highly Customizable"
                />
                <img
                  className="feature-image img-fluid mb-9 mb-lg-0 d-light-none"
                  src="../../assets/img/spot-illustrations/dark_22.png"
                  alt="Highly Customizable"
                />
              </div>
              <div className="col-lg-6">
                <h6 className="text-primary mb-2 ls-2">CUSTOMIZATION</h6>
                <h3 className="fw-bolder mb-3">Highly Customizable</h3>
                <p className="mb-4 px-md-7 px-lg-0">
                  Tailor your filenames with prefixes, descriptions, dates, versions, and more.
                  Create a naming convention that perfectly fits your needs.
                </p>
              </div>
            </div>
            <div className="row mt-2 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
              <div className="col-lg-5 order-0 order-lg-1">
                <img
                  className="feature-image img-fluid mb-9 mb-lg-0 d-dark-none"
                  src="../../assets/img/spot-illustrations/23_2.png"
                  height="394"
                  alt="Instant and Ready to Use"
                />
                <img
                  className="feature-image img-fluid mb-9 mb-lg-0 d-light-none"
                  src="../../assets/img/spot-illustrations/dark_23.png"
                  height="394"
                  alt="Instant and Ready to Use"
                />
              </div>
              <div className="col-lg-6">
                <h6 className="text-primary mb-2 ls-2">INSTANT</h6>
                <h3 className="fw-bolder mb-3">Instant & Ready to Use</h3>
                <p className="mb-4 px-md-7 px-lg-0">
                  Generate your filename with a single click and instantly copy it to your
                  clipboard. It&apos;s that simple!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <div className="position-relative">
        <div
          className="bg-holder z-2 d-none d-md-block"
          style={{
            backgroundImage: 'url(../../assets/img/bg/13.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'right',
          }}
        ></div>
        {/*/.bg-holder*/}

        <div
          className="bg-holder z-2 d-none d-md-block d-lg-none d-xl-block"
          style={{
            backgroundImage: 'url(../../assets/img/bg/bg-12.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'left',
          }}
        ></div>
        {/*/.bg-holder*/}

        <div className="bottom-0 start-0 end-0 bg-body-emphasis">
          <svg
            className="w-100"
            viewBox="0 0 1920 368"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path className="fill-body-bg" d="M1920 0.44L0 367.74V0H1920V0.44Z"></path>
          </svg>
        </div>
        <section className="pb-0 bg-body-emphasis overflow-hidden position-static">
          <div className="container-small px-lg-7 px-xxl-3">
            <div className="row">
              <div className="col-lg-6 mb-6 text-center text-lg-start z-2">
                <h4 className="text-primary fw-bolder mb-3">Testimonial</h4>
                <h2 className="mb-3 text-body-emphasis">
                  More than 2 happy
                  <br />
                  Customers and counting
                </h2>
                <p className="mb-5">
                  Concentrate on the creativity of your media products.
                  <br className="d-none d-sm-block" />
                  Don&apos;t spend hours doing the mondane task of renaming files anymore!
                  <br className="d-none d-sm-block" />
                  The entire team will get it right the first time, every time with Filename
                  Builder.
                </p>
              </div>
              <div className="col-lg-6 z-2">
                <div
                  className="carousel slide"
                  id="carouselExampleIndicators"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                        <div className="col-lg-6 col-xl-5 text-center">
                          <div className="testimonial-avatar-container d-inline-block position-relative">
                            <div
                              className="bg-holder"
                              style={{
                                backgroundImage: 'url(../../assets/img/bg/bg-2.png)',
                                backgroundSize: 'contain',
                              }}
                            ></div>
                            {/*/.bg-holder*/}
                            <img
                              className="rounded-3 mb-lg-0 opacity-100 position-relative"
                              src="../../assets/img/team/61.webp"
                              width="153"
                              height="153"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                          <div className="mb-4" data-bs-theme="light">
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                          </div>
                          <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">
                            Brilliant app! Will definitely going to be my first choice starting from
                            today
                          </h3>
                          <h6>Thomas Nugent</h6>
                          <h6 className="fw-normal">Media Lead, University of Iowa</h6>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                        <div className="col-lg-6 col-xl-5 text-center">
                          <div className="testimonial-avatar-container d-inline-block position-relative">
                            <div
                              className="bg-holder"
                              style={{
                                backgroundImage: 'url(../../assets/img/bg/bg-2.png)',
                                backgroundSize: 'contain',
                              }}
                            ></div>
                            {/*/.bg-holder*/}
                            <img
                              className="rounded-3 mb-lg-0 opacity-100 position-relative"
                              src="../../assets/img/team/8.webp"
                              width="154"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                          <div className="mb-4" data-bs-theme="light">
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                          </div>
                          <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">
                            “Excellent to work with and comfortable to customize. This is what I was
                            looking for till the date!”
                          </h3>
                          <h6>Marc Chiasson</h6>
                          <h6 className="fw-normal">UX designer, Adobe</h6>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="row g-1 g-lg-0 g-xl-1 pb-lg-3 pb-xl-0 ps-lg-1 ps-xl-0">
                        <div className="col-lg-6 col-xl-5 text-center">
                          <div className="testimonial-avatar-container d-inline-block position-relative">
                            <div
                              className="bg-holder"
                              style={{
                                backgroundImage: 'url(../../assets/img/bg/bg-2.png)',
                                backgroundSize: 'contain',
                              }}
                            ></div>
                            {/*/.bg-holder*/}
                            <img
                              className="rounded-3 mb-lg-0 opacity-100 position-relative"
                              src="../../assets/img/team/35.webp"
                              width="154"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-xl-7 text-center text-lg-start">
                          <div className="mb-4" data-bs-theme="light">
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                            <span className="fa fa-star text-primary"></span>
                          </div>
                          <h3 className="fs-7 fs-xl-6 mb-5 lh-sm me-md-7 me-lg-0">
                            “Phoenix is all you can ask for. This is perfect fit for everything you
                            might want to work on!”
                          </h3>
                          <h6>Axel Barry</h6>
                          <h6 className="fw-normal">UX designer, Apple</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* USE CASE */}
      <div className="position-relative">
        <div
          className="bg-holder world-map-bg"
          style={{ backgroundImage: 'url(../../assets/img/bg/bg-13.png)' }}
        ></div>
        {/*/.bg-holder*/}

        <div
          className="bg-holder z-2 opacity-25 "
          style={{
            backgroundImage: 'url(../../assets/img/bg/bg-right-21.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'right',
          }}
        ></div>
        {/*/.bg-holder*/}

        <div
          className="bg-holder z-2 mt-9 opacity-25"
          style={{
            backgroundImage: 'url(../../assets/img/bg/bg-left-21.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'left',
          }}
        ></div>
        {/*/.bg-holder*/}

        <svg
          className="w-100 position-relative"
          preserveAspectRatio="none"
          viewBox="0 0 1920 368"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className="fill-emphasis-bg" d="M1920 0.44L0 367.74V0H1920V0.44Z"></path>
        </svg>
        <section className="overflow-hidden z-2" id="usecase">
          <div className="container-small px-lg-7 px-xxl-3" data-bs-theme="light">
            <div className="position-relative">
              <div className="row mb-6">
                <div className="col-xl-6 text-center text-md-start">
                  <h2 className="text-white mb-2">Better Believe It!</h2>
                  <h1 className="fs-md-3 fs-xl-2 fw-black text-gradient-info text-uppercase mb-4 mb-md-0">
                    Customers
                  </h1>
                </div>
                <div className="col-xl-6 text-center text-md-start">
                  <p className="text-white">
                    You can get all the reports, data analysis, and growth maps you need with the
                    help of Filename Builder&apos;s power, and you may review and modify them
                    whenever you want. These features make this dashboard outstanding.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-8 text-center text-md-start mb-6 mb-xl-0">
                  <div className="d-md-flex justify-content-md-between">
                    <div className="mb-6 mb-md-0 me-4">
                      <h1
                        className="display-1 text-white fw-bolder"
                        data-countup='{"endValue":125,"duration":10,"suffix":"+"}'
                      >
                        125 <span>+</span>
                      </h1>
                      <p className="text-white">filenames created</p>
                    </div>
                    <div className="mb-6 mb-md-0 me-4">
                      <h1
                        className="display-1 text-white fw-bolder"
                        data-countup='{"endValue":308,"duration":10,"suffix":"k"}'
                      >
                        40
                      </h1>
                      <p className="text-white">
                        Active paid subscribers
                        <br className="d-md-none d-lg-block" />
                      </p>
                    </div>
                    <div className="mb-6 mb-md-0 me-4">
                      <h1
                        className="display-1 text-white fw-bolder"
                        data-countup='{"endValue":12,"duration":0.5}'
                      >
                        98%
                      </h1>
                      <p className="text-white">customers are satisfied</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CUSTOERM LOGOS ============================*/}
            <section className="py-5 pt-xl-13 bg-body-emphasis">
              <div className="container-small px-lg-7 px-xxl-3">
                <div className="row g-0">
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-bottom border-translucent border-end">
                      <img className="w-100" src="../../assets/img/brand2/netflix-n.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-bottom border-translucent border-end-md">
                      <img className="w-100" src="../../assets/img/brand2/blender.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-bottom border-translucent border-end border-end-md">
                      <img className="w-100" src="../../assets/img/brand2/upwork.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-bottom border-translucent border-end-lg-0">
                      <img className="w-100" src="../../assets/img/brand2/facebook-f.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-end border-bottom border-translucent border-bottom-md-0">
                      <img className="w-100" src="../../assets/img/brand2/pocket.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-end-md border-bottom border-translucent border-bottom-md-0">
                      <img
                        className="w-100"
                        src="../../assets/img/brand2/mail-bluster-1.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-end border-translucent">
                      <img className="w-100" src="../../assets/img/brand2/discord.png" alt="" />
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-end-lg-0 border-translucent">
                      <img className="w-100" src="../../assets/img/brand2/google-g.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              {/* end of .container*/}
            </section>
          </div>
        </section>
        <svg
          className="w-100 position-relative"
          viewBox="0 0 1920 368"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className="fill-emphasis-bg" d="M0 368L1920 0.730011L1920 368L0 368Z"></path>
        </svg>
      </div>

      {/* PRICING */}
      <section className="bg-body-emphasis pt-lg-0 pt-xl-8">
        <div className="container-small position-relative px-lg-7 px-xxl-3">
          <div className="mb-4 text-center text-sm-start">
            <h4 className="text-primary fw-bolder mb-3">Pricing</h4>
            <h2>Choose the best deal for you</h2>
          </div>
          <p className="column-md-2 text-center text-sm-start">
            Entice your customers with Phoenix admin dashboard. Show your best deal in this section
            to help customers choose from your best offers and place them all in one place with this
            efficient template. If you are availing more than one offer to your customers, let them
            compare among them and search for what they need to get. Show offer details here and
            entice them to buy.
          </p>
          <div className="row pt-9 g-3 g-xl-0">
            {/* Individual */}
            <div className="col-md-6 col-xl-4">
              <div className="card h-100 rounded-end-xl-0 rounded-start">
                <div className="card-body px-6">
                  <div className="px-5">
                    <div className="text-center pt-5">
                      <img
                        src="../../assets/img/icons/illustrations/pie.png"
                        width="48"
                        height="48"
                        alt=""
                      />
                      <h3 className="fw-semibold my-4">Individual</h3>
                      <p className="mb-2 text-body-secondary">For 1 user</p>
                    </div>
                    <div className="text-center">
                      <h1 className="fw-semibold text-primary">
                        $<span className="fw-bolder">6</span>
                        <span className="text-body-emphasis fs-7 ms-1 fw-bolder">USD</span>
                      </h1>
                      <h5 className="mb-4 text-body"></h5>
                      <button className="btn btn-lg mb-6 w-100 btn-outline-primary">Buy</button>
                    </div>
                  </div>
                  <ul className="fa-ul pricing-list">
                    <li className="mb-4 d-flex align-items-center">
                      <span className="fa-li">
                        <span className="fas fa-check text-primary"></span>
                      </span>
                      <span className="text-body-secondary" style={{ '--phoenix-text-opacity': 1 }}>
                        Timeline
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span className="fa-li">
                        <span className="fas fa-check text-primary"></span>
                      </span>
                      <span className="text-body-secondary" style={{ '--phoenix-text-opacity': 1 }}>
                        Advanced Search
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span
                        className="text-body-secondary"
                        style={{ '--phoenix-text-opacity': '.5' }}
                      >
                        Custom fields
                      </span>
                      <span className="badge badge-phoenix badge-phoenix-warning ms-2 fs-10 opacity-50">
                        New
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span
                        className="text-body-secondary"
                        style={{ '--phoenix-text-opacity': '.5' }}
                      >
                        Task dependencies
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span
                        className="text-body-secondary"
                        style={{ '--phoenix-text-opacity': '.5' }}
                      >
                        Private teams &amp; projects
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Team */}
            <div className="col-md-6 col-xl-4">
              <div className="card h-100  rounded-top-0 rounded-xl-0 border border-2 border-primary mt-5 mt-md-0">
                <div className="position-absolute d-flex flex-center bg-primary-subtle rounded-top py-1 end-0 start-0 badge-pricing">
                  <p className="text-primary-dark mb-0">Most popular</p>
                </div>
                <div className="card-body px-6">
                  <div className="px-5">
                    <div className="text-center pt-5">
                      <img
                        src="../../assets/img/icons/illustrations/bolt.png"
                        width="48"
                        height="48"
                        alt=""
                      />
                      <h3 className="fw-semibold my-4">Team</h3>
                      <p className="mb-2 text-body-secondary">Up to 10 users</p>
                    </div>
                    <div className="text-center">
                      <h1 className="fw-semibold text-primary">
                        $<span className="fw-bolder">12</span>
                        <span className="text-body-emphasis fs-7 ms-1 fw-bolder">USD</span>
                      </h1>
                      <h5 className="mb-4 text-body"></h5>
                      <button className="btn btn-lg mb-6 w-100 btn-primary">Buy</button>
                    </div>
                  </div>
                  <ul className="fa-ul pricing-list">
                    <li className="mb-4 d-flex align-items-center">
                      <span className="fa-li">
                        <span className="fas fa-check text-primary"></span>
                      </span>
                      <span className="text-body-secondary" style={{ '--phoenix-text-opacity': 1 }}>
                        Timeline
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span className="fa-li">
                        <span className="fas fa-check text-primary"></span>
                      </span>
                      <span className="text-body-secondary" style={{ '--phoenix-text-opacity': 1 }}>
                        Advanced Search
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span className="fa-li">
                        <span className="fas fa-check text-primary"></span>
                      </span>
                      <span className="text-body-secondary" style={{ '--phoenix-text-opacity': 1 }}>
                        Custom fields
                      </span>
                      <span className="badge badge-phoenix badge-phoenix-warning ms-2 fs-10">
                        New
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span
                        className="text-body-secondary"
                        style={{ '--phoenix-text-opacity': '.5' }}
                      >
                        Task dependencies
                      </span>
                    </li>
                    <li className="mb-4 d-flex align-items-center">
                      <span
                        className="text-body-secondary"
                        style={{ '--phoenix-text-opacity': '.5' }}
                      >
                        Private teams &amp; projects
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Enterprise */}
            <div className="col-12 col-md-6 col-xl-4 ps-xl-4">
              <div className="row g-0 h-100 justify-content-center">
                <div className="col-xl-12">
                  <div className="card h-100 mt-5 mt-md-0">
                    <div className="card-body">
                      <div className="px-5">
                        <div className="text-center pt-5">
                          <img
                            src="../../assets/img/icons/illustrations/shield.png"
                            width="48"
                            height="48"
                            alt=""
                          />
                          <h3 className="fw-semibold my-4">Enterprise</h3>
                          <p className="mb-2 text-body-secondary">Unlimited users</p>
                        </div>
                        <div className="text-center">
                          <h1 className="fw-semibold text-primary">
                            $<span className="fw-bolder">40</span>
                            <span className="text-body-emphasis fs-7 ms-1 fw-bolder">USD</span>
                          </h1>
                          <h5 className="mb-4 text-body"></h5>
                          <button className="btn btn-lg mb-6 w-100 btn-outline-primary">Buy</button>
                        </div>
                      </div>
                      <ul className="fa-ul pricing-list">
                        <li className="mb-4 d-flex align-items-center">
                          <span className="fa-li">
                            <span className="fas fa-check text-primary"></span>
                          </span>
                          <span
                            className="text-body-secondary"
                            style={{ '--phoenix-text-opacity': 1 }}
                          >
                            Timeline
                          </span>
                        </li>
                        <li className="mb-4 d-flex align-items-center">
                          <span className="fa-li">
                            <span className="fas fa-check text-primary"></span>
                          </span>
                          <span
                            className="text-body-secondary"
                            style={{ '--phoenix-text-opacity': 1 }}
                          >
                            Advanced Search
                          </span>
                        </li>
                        <li className="mb-4 d-flex align-items-center">
                          <span className="fa-li">
                            <span className="fas fa-check text-primary"></span>
                          </span>
                          <span
                            className="text-body-secondary"
                            style={{ '--phoenix-text-opacity': 1 }}
                          >
                            Custom fields
                          </span>
                          <span className="badge badge-phoenix badge-phoenix-warning ms-2 fs-10">
                            New
                          </span>
                        </li>
                        <li className="mb-4 d-flex align-items-center">
                          <span className="fa-li">
                            <span className="fas fa-star text-primary"></span>
                          </span>
                          <span
                            className="text-body-secondary"
                            style={{ '--phoenix-text-opacity': 1 }}
                          >
                            Task dependencies
                          </span>
                        </li>
                        <li className="mb-4 d-flex align-items-center">
                          <span className="fa-li">
                            <span className="fas fa-star text-primary"></span>
                          </span>
                          <span
                            className="text-body-secondary"
                            style={{ '--phoenix-text-opacity': 1 }}
                          >
                            Private teams &amp; projects
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center mt-8">
              <p>
                For Enterprise Solution with Dedicated Support and more -{' '}
                <a href="#!"> Contact us</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Us */}
      <section className="bg-body-emphasis">
        <div className="container-small px-lg-7 px-xxl-3">
          <div className="mb-3 text-center text-sm-start">
            <h4 className="text-primary fw-bolder mb-3">Contact Us</h4>
            <h2>What can we help with:</h2>
          </div>
          <div className="row g-5 g-lg-5">
            <div className="col-md-6 mb-5 mb-md-0 text-center text-md-start">
              <h3 className="mb-3">Stay connected</h3>
              <p className="mb-5">
                Filename Builder is available for your support 24/7. We are here to help you with
                your questions or suggestions at all times.
              </p>
              <div className="d-flex flex-column align-items-center align-items-md-start gap-3 gap-md-0">
                <div className="d-md-flex align-items-center">
                  <div className="icon-wrapper shadow-info">
                    <span
                      className="uil uil-envelope text-primary fs-4 z-1 ms-2"
                      data-bs-theme="light"
                    ></span>
                  </div>
                  <div className="flex-1 ms-3">
                    <a className="fw-semibold text-body" href="mailto:thomas@filnamebuilder.com">
                      thomas@filenamebuilder.com
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <a href="#!">
                    <span className="fa-brands fa-facebook fs-6 text-primary me-3"></span>
                  </a>
                  <a href="#!">
                    <span className="fa-brands fa-twitter fs-6 text-primary me-3"></span>
                  </a>
                  <a href="#!">
                    <span className="fa-brands fa-linkedin-in fs-6 text-primary"></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 text-center text-md-start mb-14">
              <h3 className="mb-3">Drop us a line</h3>
              <form className="row g-4">
                <div className="col-12">
                  <input
                    className="form-control bg-body-emphasis"
                    type="text"
                    name="name"
                    placeholder="Name"
                    required="required"
                  />
                </div>
                <div className="col-12">
                  <input
                    className="form-control bg-body-emphasis"
                    type="email"
                    name="email"
                    placeholder="Email"
                    required="required"
                  />
                </div>
                <div className="col-12">
                  <textarea
                    className="form-control bg-body-emphasis"
                    rows="6"
                    name="message"
                    placeholder="Message"
                    required="required"
                  ></textarea>
                </div>
                <div className="col-12 d-grid">
                  <button className="btn btn-outline-primary" type="submit">
                    Submit
                  </button>
                </div>
                <div className="feedback"></div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* BG SHAPES vertical spacer for footer */}
      <section>
        <div
          className="bg-holder z-2"
          style={{
            backgroundImage: 'url(../../assets/img/bg/bg-left-17.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'left center',
          }}
        ></div>
        {/*/.bg-holder*/}

        <div
          className="bg-holder z-2"
          style={{
            backgroundImage: 'url(../../assets/img/bg/bg-right-17.png)',
            backgroundSize: 'auto',
            backgroundPosition: 'right center',
          }}
        ></div>
        {/*/.bg-holder*/}

        <div className="position-absolute top-0 end-0 start-0">
          <svg
            className="w-100 text-white"
            preserveAspectRatio="none"
            viewBox="0 0 1920 368"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path className="fill-emphasis-bg" d="M1920 0.44L0 367.74V0H1920V0.44Z"></path>
          </svg>
        </div>
        <div className="position-absolute bottom-0 end-0 start-0">
          <svg
            className="text-white w-100"
            viewBox="0 0 1920 368"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path className="fill-emphasis-bg" d="M0 368L1920 0.730011L1920 368L0 368Z"></path>
          </svg>
        </div>
      </section>
    </>
  );
}
